// extracted by mini-css-extract-plugin
export default {"setPassword":"setPassword_setPassword__n-Gp7","setPassword__actions":"setPassword_setPassword__actions__fI3e-"};